import React, { useState, useRef, useEffect } from 'react';
import * as d3 from 'd3';
import '../styles/Charts.css';

const ChartBarOrdinal = ({dataProps}) => {
    // preset data if data props not given
    const [dataBar, updateDataBarOrdinal] = useState([
        {property: 'Staff', value: 10},
        {property: 'System', value: 27},
        {property: 'Other', value: 19}
    ]) 
    
    const data = dataProps || dataBar;
    const svgRef = useRef();

    const margin = { 
        top: 20,
        right: 30,
        bottom: 40,
        left: 40
    };

    const width = 400 - margin.left - margin.right;
    const height = 300 - margin.top - margin.bottom;

    useEffect(()=>{
        if (!data || data.length === 0) return;

        const svg = d3.select(svgRef.current)
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top})`);

        // X scale
        const x = d3.scaleBand()
            .domain(data.map(d => d.property))
            .range([0, width])
            .padding(0.1);

        // Y scale
        const y = d3.scaleLinear()
            .domain([0, d3.max(data, d => d.value)])
            .nice()
            .range([height, 0]);

        // X axis
        svg.append('g')
            .attr('transform', `translate(0, ${height})`)
            .call(d3.axisBottom(x));

        // Y axis
        svg.append('g')
            .call(d3.axisLeft(y));

        // Bars
        svg.selectAll('.bar')
            .data(data)
            .enter()
            .append('rect')
            .attr('class', 'bar')
            .attr('x', d => x(d.property))
            .attr('y', d => y(d.value))
            .attr('width', x.bandwidth())
            .attr('height', d => height - y(d.value))
            .attr('fill', '#69b3a2');

        // Create legends table above chart
        // const labelsArea = d3.select('#labelsBar');
        // labelsArea.selectAll('*').remove();

        // const legendData = [
        //     { label: 'Categories', color: '#69b3a2' },
        // ];

        // const labelDivs = labelsArea.selectAll('div')
        //     .data(legendData)
        //     .enter()
        //     .append('div')
        //     .attr('class', 'label-container');

        // labelDivs.append('div')
        //     .attr('class', 'color-circle')
        //     .style('background-color', d => d.color);

        // labelDivs.append('span')
        //     .text(d => d.label)
        //     .attr('class', 'text-legend');

    }, [data, height, margin.bottom, margin.left, margin.right, margin.top, width]);

    return (
        <div>
            <article id='labelsBar'>
                {/* data legend will be here */}
            </article>
            <svg
            ref={svgRef}
            // width={width}
            // height={height}
            >
            </svg>
        </div>  
    )
}

export default ChartBarOrdinal